import { render, staticRenderFns } from "./CommissionInfoModal.vue?vue&type=template&id=9a5c910e&scoped=true&"
import script from "./CommissionInfoModal.vue?vue&type=script&lang=js&"
export * from "./CommissionInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5c910e",
  null
  
)

export default component.exports